// Store of the app
import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import application from './modules/application';
import authentification from './modules/authentification';
import conf from './modules/conf';

Vue.use(Vuex);
require('es6-promise').polyfill();

export default new Vuex.Store({
  // assign modules to the store
  modules: {
    authentification,
    application,
    conf,
  },

  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js